import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Sidebar = withSafeSuspense(lazy(async () => ({
  default: (await import('./sidebar')).Sidebar
})))
